/// <reference types="datatables.net" />

import { Component, OnInit } from "@angular/core";
import { AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { ApiIntegration } from "../../_services/api.integration";
import { AlertService } from "../../_services/alert.service";
import { DataTableDirective } from "angular-datatables";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { User } from "../../_models/user";
import { Subject } from "rxjs";
import { Register } from "../../_models/register";
import { Caller } from "../../_models/caller";
import { Globals } from "../../_models/globals";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { saveAs } from "file-saver";
import { ExcelServiceService } from "../../_models/excel-service.service";

@Component({
  selector: "app-account-owner-list",
  templateUrl: "./account-owner-list.component.html",
  styleUrls: ["./account-owner-list.component.css"],
})
export class AccountOwnerListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  accountOwners: any;
  tabClicked: string = "all";
  warehouses: any;
  newPassword: any;
  renterPassword: any;
  errorMessage: string;
  confirmPassword: string;
  currentPassword: string;
  confirmPwdError: string = '';
  newPwdError: string = '';
  currentPwdError: string = '';
  popUp: string = 'N';
  masterSelected: boolean = false;
  ownerStatus: any = "ALL";
  previousStatus = "";
  userDrop2: any = "ALL";
  totalRecords: number;
  checkedList = [];

  constructor(
    private alertService: AlertService,
    private excelService: ExcelServiceService,
    private http: HttpClient,
    private router: Router,
    private api: ApiIntegration,
    private g: Globals,
    public user: User,
    public register: Register,
    public caller: Caller
  ) {
    this.g.page = " Customers";
    //this.getAccountOwners("ALL");
    this.populateTabData("all", "ALL");
  }

  populate(orderChange) {
    this.api.getAllCustomersList(orderChange).subscribe(
      (data: any) => {
        this.g.loaderDisplay = "";
        this.accountOwners = data.ownersResponseList;
      },
      (err) => {
        this.g.loaderDisplay = "";

        this.alertService.error("Error", err);
      }
    );
  }

  getAccountOwners(status) {
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.dtOptions = {
      pagingType: "full_numbers",
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: "Search by Company Name / Contact / Email",
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.ownerStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.ownerStatus;
        }
        let query: any = {
          page: dataTablesParameters.start
            ? dataTablesParameters.start / dataTablesParameters.length
            : dataTablesParameters.start,
          size: dataTablesParameters.length,
        };
        if (
          (dataTablesParameters.search || {}).value &&
          (dataTablesParameters.search || {}).value.trim() !== ""
        ) {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http
          .get(
            environment.apiUrl +
            "api/getAllCustomersList/" +
            this.ownerStatus,
            {
              params: query,
              headers: header1,
            }
          )
          .subscribe(
            (resp: any) => {
              this.accountOwners = resp.ownersResponseList;
              this.totalRecords = resp.noOfRecords;
              this.accountOwners.forEach((s) => {
                s["isSelected"] = false;
              });
              this.g.loaderDisplay = "";
              callback({
                recordsTotal: resp.noOfRecords,
                recordsFiltered: resp.noOfRecords,
              });
            },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error("Error", err);
            }
          );
      },
    };
  }

  populateTabData(triggered, ownerStatus) {
    this.tabClicked = triggered;
    this.ownerStatus = ownerStatus;
    if (!this.previousStatus) {
      this.getAccountOwners(ownerStatus);
    } else {
      this.rerender();
    }
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.accountOwners, "sample");
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  selectAccountOwner(ao) {
    this.user.role = "ACCOUNT_OWNER";
    this.user.accountOwnerId = ao.id;
    this.user.accountOwnerName = ao.ownerName;
    this.user.userName = ao.userName;
    this.user.userId = ao.userId;
    this.router.navigate(["/admin/dashboard"]);
  }

  changeStatus(c, index) {
    this.g.loaderDisplay = "display";
    if (c.status == "ACTIVE") {
      c.status = "IN_ACTIVE";
    } else {
      c.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateAOStatus",
        {
          id: c.id,
          organizationId: 1,
          status: c.status,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          if (data["code"] == "200") {
            this.accountOwners.splice(index, 1);
            this.alertService.success(
              "Customer",
              "Status Updated Successfully"
            );
            this.rerender();
          } else {
            if (c.status == "ACTIVE") {
              c.status = "IN_ACTIVE";
            } else {
              c.status = "ACTIVE";
            }
            this.alertService.error(data["message"]);
          }

          this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
    if (this.tabClicked != "all") {
      this.rerender();
    }
  }

  selectAOwner(ao) {
    if (!ao.isSelected) {
      this.masterSelected = false;
    }
    this.getCheckedAccountOwnerList();
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  checkUncheckAll() {
    for (var i = 0; i < this.accountOwners.length; i++) {
      this.accountOwners[i].isSelected = this.masterSelected;
    }
    this.getCheckedAccountOwnerList();
  }

  getCheckedAccountOwnerList() {
    this.checkedList = [];
    for (var i = 0; i < this.accountOwners.length; i++) {
      if (this.accountOwners[i].isSelected) {
        this.checkedList.push(this.accountOwners[i]["id"]);
      }
    }
  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = "";
  }

  editAccountOwner(accountOwners) {
    let i = 0;
    let ohid;
    for (let ao of accountOwners) {
      if (ao.isSelected) {
        i = i + 1;
        ohid = ao.id;
      }
    }
    if (i === 1) {
      this.router.navigate(["/admin/editAccountOwner/" + ohid]);
    } else {
      this.errorMessage =
        "Can not edit multiple account owners at once. Please select one at a time";
    }
  }

  showWarehouse(id) {
    this.api.getWarehousesByAccountOwner(id).subscribe(
      (data: any) => {
        this.g.loaderDisplay = "";
        this.warehouses = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openPasswordPopup(ao) {
    this.popUp = 'Y';
  }

  closePasswordPopup() {
    this.popUp = 'N';
  }

  typeConfirmPwd() {
    this.confirmPwdError = '';
    if (!this.confirmPassword) {
      this.confirmPwdError = 'Please enter confirm password';
    } else if (this.confirmPassword !== this.newPassword) {
      this.confirmPwdError = 'Password does not match';
    }
  }

  typeNewPwd() {
    this.newPwdError = '';
    if (!this.newPassword) {
      this.newPwdError = 'Please enter new password';
    } else if (this.newPassword.length <= 5) {
      this.newPwdError = 'Password must be minimum 6 characters';
    }
  }

  typeCurrentPwd() {
    this.currentPwdError = '';
    if (!this.currentPassword) {
      this.currentPwdError = 'Please enter current password';
    }
  }
    submitChangePassword() {
      this.typeNewPwd();
      this.typeCurrentPwd();
      this.typeConfirmPwd();
      if (this.confirmPwdError != "" || this.newPwdError != "" || this.currentPwdError != "") {
        return false;
      }
      let request = {
        "currentPassword": this.currentPassword,
        "newPassword": this.newPassword
      };
      this.g.loaderDisplay = "display";
      this.api.changePassword(request).subscribe((data: any = []) => {
        if (data['code'] == 200) {
          this.g.loaderDisplay = "";
          this.currentPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
          this.closePasswordPopup();
          this.alertService.success('Password', 'Changed Successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
      }, err => {
        this.g.loaderDisplay = "";
        console.log(err);
        this.alertService.error('Error', 'Change Password Failed, please re-try.');
      });

    }


  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false;
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < (this.accountOwners || []).length; i++) {
      if (this.accountOwners[i].isSelected) {
        this.checkedList.push(this.accountOwners[i]['id']);
      }
    }
  }

  processPayment() {
    this.router.navigate(["/admin/walletPayment/" + this.checkedList[0]]);
  }
}
